export default __webpack_public_path__ + "static/media/img555.ea602c19.png";